import React, { useState } from "react";

const WA_NUMBER = "919873385555";
const WA_MESSAGE = encodeURIComponent("Hi! I'm interested in IndiaCloud services. Can you help me?");
const WA_URL = `https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`;

export default function ChatbotWidget() {
  const [hovered, setHovered] = useState(false);
  const [tooltip, setTooltip] = useState(true);

  // Hide tooltip after 5 seconds on mount
  React.useEffect(() => {
    const t = setTimeout(() => setTooltip(false), 5000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9999, display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 10 }}>

      {/* Tooltip bubble */}
      {tooltip && (
        <div
          onClick={() => setTooltip(false)}
          style={{
            background: "#fff",
            color: "#111",
            padding: "10px 16px",
            borderRadius: 12,
            fontSize: 13,
            fontFamily: "Outfit, sans-serif",
            fontWeight: 500,
            boxShadow: "0 4px 24px rgba(0,0,0,0.18)",
            maxWidth: 220,
            lineHeight: 1.5,
            cursor: "pointer",
            position: "relative",
            animation: "fadeInUp 0.4s ease",
          }}
        >
          💬 Chat with us on WhatsApp!
          <div style={{
            position: "absolute", bottom: -8, right: 20,
            width: 0, height: 0,
            borderLeft: "8px solid transparent",
            borderRight: "8px solid transparent",
            borderTop: "8px solid #fff",
          }} />
        </div>
      )}

      {/* WhatsApp Button */}
      <a
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Chat with us on WhatsApp"
        style={{
          display: "flex",
          alignItems: "center",
          gap: hovered ? 10 : 0,
          background: "#25D366",
          borderRadius: 50,
          padding: hovered ? "14px 22px 14px 18px" : "14px",
          boxShadow: hovered
            ? "0 8px 32px rgba(37,211,102,0.55), 0 0 0 4px rgba(37,211,102,0.15)"
            : "0 4px 20px rgba(37,211,102,0.4)",
          textDecoration: "none",
          transition: "all 0.3s cubic-bezier(0.34,1.56,0.64,1)",
          transform: hovered ? "scale(1.08)" : "scale(1)",
          overflow: "hidden",
          maxWidth: hovered ? 200 : 52,
          whiteSpace: "nowrap",
        }}
      >
        {/* WhatsApp SVG icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          width={24}
          height={24}
          fill="#fff"
          style={{ flexShrink: 0 }}
        >
          <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
        </svg>

        {/* Label that slides in on hover */}
        <span style={{
          color: "#fff",
          fontFamily: "Outfit, sans-serif",
          fontWeight: 600,
          fontSize: 14,
          opacity: hovered ? 1 : 0,
          maxWidth: hovered ? 130 : 0,
          transition: "opacity 0.25s ease, max-width 0.3s ease",
          overflow: "hidden",
        }}>
          Chat with us
        </span>
      </a>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
